import React from "react";
import { cn } from "@/lib/utils";
import {
  mapLegacyStatusToNewStatus,
  getStatusLabel,
  getStatusColor,
  type ProposalStatus,
} from "@/lib/proposalStatus";

interface ProposalStatusBadgeProps {
  status: string | null | undefined;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const ProposalStatusBadge: React.FC<ProposalStatusBadgeProps> = ({
  status,
  className,
  size = "md",
}) => {
  const normalizedStatus = mapLegacyStatusToNewStatus(status);
  const label = getStatusLabel(status);
  const colors = getStatusColor(status);

  const sizeClasses = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-3 py-1 text-sm",
    lg: "px-4 py-1.5 text-base",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full font-semibold whitespace-nowrap",
        sizeClasses[size],
        className
      )}
      style={{
        backgroundColor: `hsl(${colors.bg})`,
        color: `hsl(${colors.text})`,
      }}
    >
      {label}
    </span>
  );
};

export default ProposalStatusBadge;
